import { render, staticRenderFns } from "./ContentPlaceholder.vue?vue&type=template&id=5b7288e1&scoped=true&"
import script from "./ContentPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ContentPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ContentPlaceholder.vue?vue&type=style&index=0&id=5b7288e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7288e1",
  null
  
)

export default component.exports